// extracted by mini-css-extract-plugin
export var lazyBackground = "lazyBackground-module--lazyBackground--i0Q-x";